// extracted by mini-css-extract-plugin
export default {"TypesMenu":"InputWidget_TypesMenu__toLx8","InputWrapper":"InputWidget_InputWrapper__uTL4f","ChooseType":"InputWidget_ChooseType__7TU76"};